module.exports = __webpack_public_path__ + "img/menu.91f689e5.svg";